var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1549_5963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5991 5.17031V4C12.5991 3.44844 12.1507 3 11.5991 3H1.09912C0.547559 3 0.0991211 3.44844 0.0991211 4V12C0.0991211 12.5516 0.547559 13 1.09912 13H11.5991C12.1507 13 12.5991 12.5516 12.5991 12V10.8297C12.5991 10.6484 12.7851 10.5281 12.9507 10.6016L14.6929 11.375C15.3538 11.6687 16.0991 11.1844 16.0991 10.4609V5.53906C16.0991 4.81562 15.3538 4.33125 14.6929 4.625L12.9507 5.4C12.7851 5.47344 12.5991 5.35156 12.5991 5.17031ZM11.3491 12H1.34912C1.21162 12 1.09912 11.8875 1.09912 11.75V4.25C1.09912 4.1125 1.21162 4 1.34912 4H11.3491C11.4866 4 11.5991 4.1125 11.5991 4.25V11.75C11.5991 11.8875 11.4866 12 11.3491 12ZM14.7476 10.3047L12.7476 9.41562C12.6569 9.375 12.5991 9.28594 12.5991 9.1875V6.8125C12.5991 6.71406 12.6569 6.62344 12.7476 6.58437L14.7476 5.69531C14.9132 5.62188 15.0991 5.74219 15.0991 5.92344V10.0766C15.0991 10.2578 14.9132 10.3781 14.7476 10.3047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29287 6.95937L7.09756 7.99999L5.29443 9.04062V6.95937M5.04443 5.77499C4.65224 5.77499 4.29287 6.08749 4.29287 6.52656V9.47499C4.29287 9.91249 4.65224 10.2266 5.04443 10.2266C5.16943 10.2266 5.29756 10.1953 5.41787 10.125L7.97099 8.64999C8.47099 8.36093 8.47099 7.63906 7.97099 7.35156L5.41787 5.87656C5.29756 5.80624 5.16943 5.77499 5.04443 5.77499Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1549_5963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvr);
export default __webpack_public_path__ + "static/media/dvr.f3c5194fb2cd32a51983aee439c4f80a.svg";
export { ForwardRef as ReactComponent };